export class PtaSousActivite {
  code_sous_activite: any;
  sous_activite: any;
  code_activite: any;
  activite: any;
  date_debut: any;
  date_fin: any;
  amputation_budgetaire: any;
  mode_execution: any;
  poids: any;
  mt_financement_etat: any;
  mt_financement_fond_propre: any;
  mt_financement_ptf: any;
  est_revue: any;
  pta_id: any;
  pta_activite_id: any;
  reference: any;
  programme_id: any;
  structures_associees: any;
  structure_responsable: any;
  total: any;
  total_engage: any;
  total_ordonnance: any;
  total_encaissement: any;
  total_decaisse: any;
  total_a_decaisser: any;
  date_engagement: any;
  date_ordonnance: any;
  date_encaissement: any;
  date_decaissement: any;

  total_a_ordonnancer: any;
  total_a_encaisser: any;
  reste: any;

  fichier:any;
  no_fichier:any;

  no_contrat: any;
    preuve: any;
    no_fiche: any;
    no_mandat: any;
    lien_mandat: any;
    sousActiviteItem: any;
    observations: any;
  private errorMessage: string;

  constructor() {
    this.errorMessage = "";
  }

  // Get error message
  getErrorMessage(): string {
    return this.errorMessage;
  }

  // Check for save
  canOrdonnance(): boolean {
    // Validate required fields
    if (this.total_ordonnance === undefined || this.total_ordonnance === null) {
      this.errorMessage = "Veuillez saisir le montant ordonnancé";
      return false;
    }

    if (this.date_ordonnance === undefined || this.date_ordonnance === null) {
      this.errorMessage = "Veuillez saisir la date d'ordonnance";
      return false;
    }


    

    // Clear the error message if all validations pass
    this.errorMessage = "";
    return true;
  }//end canOrdonnance

  // Check for save
  canSaveEngagement(): boolean {

    if (this.total_engage === undefined || this.total_engage === null) {
      this.errorMessage = "Veuillez saisir le montant engagé";
      return false;
    }

    if (this.date_engagement === undefined || this.date_engagement === null) {
      this.errorMessage = "Veuillez saisir la date d'engagement";
      return false;
    }

    this.errorMessage = "";
    return true;
  }//end canSaveEngagement


  canEncaissement(): boolean {
    // Validate required fields
    if (this.total_a_decaisser === undefined || this.total_a_decaisser === null) {
      this.errorMessage = "Veuillez saisir le montant à décaissé";
      return false;
    }

    if (this.date_decaissement === undefined || this.date_decaissement === null) {
      this.errorMessage = "Veuillez saisir la date de décaissement";
      return false;
    }

    // Clear the error message if all validations pass
    this.errorMessage = "";
    return true;
  }

  canDecaissement(): boolean {
    if (this.total_a_decaisser === undefined || this.total_a_decaisser === null) {
      this.errorMessage = "Veuillez saisir le montant decaissé";
      return false;
    }

    if (this.date_decaissement === undefined || this.date_decaissement === null) {
      this.errorMessage = "Veuillez saisir la date de decaissement";
      return false;
    }

    // Clear the error message if all validations pass
    this.errorMessage = "";
    return true;
  }
}
